import React from 'react';

import { Box, Stack } from '@mui/material';

import type { PayloadBuilderState } from '~/utils/societePayloadBuilder/types';

import LoadPayloadSection from './LoadPayloadSection';
import { PAYLOAD_BUILDER_REQUIRED_FIELDS_SX } from './PayloadBuilderShared';
import StatusClaimForm from './StatusClaimForm';
import StatusMatchForm from './StatusMatchForm';

interface PayloadBuilderFormProps {
  state: PayloadBuilderState;
  onChange: (next: PayloadBuilderState) => void;
  loadJson: string;
  onLoadJsonChange: (value: string) => void;
  loadError: string | null;
  onLoadPayload: () => void;
  onClearLoad: () => void;
  onUploadFile: (file: File) => void;
}

export default function PayloadBuilderForm({
  state,
  onChange,
  loadJson,
  onLoadJsonChange,
  loadError,
  onLoadPayload,
  onClearLoad,
  onUploadFile,
}: PayloadBuilderFormProps) {
  return (
    <Stack spacing={2}>
      <LoadPayloadSection
        loadJson={loadJson}
        loadError={loadError}
        onLoadJsonChange={onLoadJsonChange}
        onLoadPayload={onLoadPayload}
        onClearLoad={onClearLoad}
        onUploadFile={onUploadFile}
      />

      <Box sx={PAYLOAD_BUILDER_REQUIRED_FIELDS_SX}>
        {state.mode === 'statusMatch' ? (
          <StatusMatchForm state={state} onChange={onChange} />
        ) : (
          <StatusClaimForm state={state} onChange={onChange} />
        )}
      </Box>
    </Stack>
  );
}
